import { Timer } from '@visiba/std';
import { ReactNode, useEffect, useState } from 'react';
import { useConstant } from '../hooks/use_constant';

interface Props {
	delay?: number;
	children: ReactNode;
}

export function DelayedRender({ delay = 250, children }: Props): JSX.Element | null {
	const [shouldRender, setShouldRender] = useState(false);
	const timer = useConstant(() => new Timer());

	useEffect(
		function whenMounted() {
			return timer.wait(() => setShouldRender(true), delay);
		},
		[timer, delay],
	);

	if (!shouldRender) {
		return null;
	}

	return <>{children}</>;
}
